import { React, models, kea, history, resources, selectores, componentToRx, Route, match, validation, createSelectorRx, formfields } from "app/main/std";

import { Checkbox  } from "kea-react";

type Entity = models.ParamsEstadisticasClientes;

interface Props {
    idVendedor: number | null;
    orderByTotal : boolean
}

export interface State {
    value: Entity;
}

/**
* Componente para editar un Entity
*/
class ReporteEstadisticasClientesNoRX extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            value: {
                IdVendedor: this.props.idVendedor,
                orderByTotal: false
            } as Entity
        };

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    tieneVendedor = (x: Props) => x.idVendedor != null;

    errors = () => validation.getErrors(this.rules, this.state.value);
    getField = formfields(() => ({
        value: this.state.value,
        onChange: (x: Entity) => this.setState({ value: x })
    }), this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            fechaDesde: validation.required,
            fechaHasta: validation.required,
            tipoReporte: validation.required
        };
    }

    onGenerarEstadisticasClientes = async () => {
        const reporte = await resources.RepEstadisticasClientes.Generar(this.state.value);
        await kea.download(reporte, "Reporte estadísticas de clientes.xls");
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.name === 'OrderCheckbox' ? target.checked : target.value;
        
        this.state.value.orderByTotal = value
      }
    

    render() {
        const getField = this.getField;
        const DateTime = getField(kea.DateTime);
        const Cliente = getField(selectores.Cliente);
        const Sucursal = getField(selectores.Sucursal);
        const Vendedor = getField(selectores.Vendedor);
        const TipoReporte = getField(selectores.TipoReporteEstadisticasClientesSelector);
        const tieneVendedor = this.tieneVendedor(this.props);
        return (
            <div>
                <kea.Title titulo="Reporte de estadísticas de clientes" onRegresar={() => history.go("../")} />

                {kea.autogrid(6, [
                    <DateTime field="fechaDesde" label="Fecha desde" />,
                    <DateTime field="fechaHasta" label="Fecha hasta" />,
                    <TipoReporte field="tipoReporte" label="Tipo de reporte" />,
                    <Sucursal field="idSucursal" label="Sucursal" />,
                    <Cliente field="idCliente" label="Cliente" />,
                    <Vendedor field="IdVendedor" label="Ejecutivo de ventas" readonly={tieneVendedor} />,
                    <label>
                    Ordenar por total:
                    <input
                        name="OrderCheckbox"
                        type="checkbox"
                        onChange={this.handleInputChange} 
                        />
                    </label>
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.Button children="Generar reporte" style="success" onClick={this.onGenerarEstadisticasClientes} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}


const ReporteEstadisticasClientesRx = componentToRx(ReporteEstadisticasClientesNoRX);

export class ReporteEstadisticasClientes extends React.PureComponent {

    idUsuario = () => resources.User.getIdUsuario();
    usuario = createSelectorRx(this.idUsuario, async idUsuario => idUsuario ? await resources.Usuario.getMemo(idUsuario) : null);
    idVendedor = createSelectorRx(this.usuario, usuario => usuario ? usuario.IdVendedor : null);

    render() {
        const idVendedor = this.idVendedor(this);
        return <ReporteEstadisticasClientesRx
            idVendedor={idVendedor}
        />
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reporteestadisticasclientes/index.tsx